import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['H'] as const;

const unit = z.literal('H').default('H');

const valueValidator = AbstractMeasurement.nomOptionalMinMax
    .extend({
        unit,
    })
    .default({});

const minMaxValidator = AbstractMeasurement.minMax
    .extend({
        unit,
    })
    .default({});

export const Inductance = {
    validators: {
        value: valueValidator,
        minMax: minMaxValidator,
        unit,
    },
    units,
};

export type Inductance = z.infer<typeof valueValidator>;
